import script from "./file-upload.vue?vue&type=script&setup=true&lang=ts"
export * from "./file-upload.vue?vue&type=script&setup=true&lang=ts"

import "./file-upload.vue?vue&type=style&index=0&id=2f22b40a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f22b40a"]])

export default __exports__